<template>
    <!-- Quantity -->
    <el-tooltip
        effect="dark"
        popper-class="licence-product-tooltip"
        v-model="showTooltip"
        :manual="!disabledQuantity"
        placement="bottom-start"
    >
        <template #content>
            <span v-html="tooltipLabel"></span>
        </template>
        <el-input-number
            ref="licenceProduct"
            class="licence-product-quantity"
            :class="{ 'licence-deleted': licencesBeDeleted }"
            step-strictly
            :disabled="disabledQuantity"
            :value="quantityProduct"
            :min="minQuantity"
            @change="(val) => $emit('update', val)"
        >
        </el-input-number>
    </el-tooltip>
</template>
<script>
export default {
    props: {
        price: {
            type: Object,
            required: true,
        },
        isSaleUser: {
            type: Boolean,
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
        freeLicences: {
            type: Object,
            required: true,
        },
        saleLimitation: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            showTooltip: false,
        };
    },
    mounted() {
        if (!this.isSaleUser) {
            const inputMinus = this.$refs.licenceProduct.$el.querySelector(
                '.el-input-number__decrease',
            );
            inputMinus.addEventListener(
                'mouseover',
                (e) => this.handleDecreaseTooltip(e, true),
                false,
            );
            inputMinus.addEventListener(
                'mouseout',
                (e) => this.handleDecreaseTooltip(e, false),
                false,
            );
        }
    },
    beforeDestroy() {
        if (!this.isSaleUser) {
            const inputMinus = this.$refs.licenceProduct.$el.querySelector(
                '.el-input-number__decrease',
            );
            inputMinus.removeEventListener(
                'mouseover',
                (e) => this.handleDecreaseTooltip(e, true),
                false,
            );
            inputMinus.removeEventListener(
                'mouseout',
                (e) => this.handleDecreaseTooltip(e, false),
                false,
            );
        }
    },
    computed: {
        /**
         * Min quantity is set for client
         * SaleLimitation as renew limitation, minimum quantity is equal to product Quantity as suggested licences
         */
        minQuantity() {
            if (this.saleLimitation && this.isSaleUser) {
                return this.product.quantity >
                    this.product.customPricing.find((price) => price.up_to === 'inf').min
                    ? 0
                    : this.price.qt;
            }
            return _.isNil(this.price.min) || (this.isSaleUser && !this.saleLimitation)
                ? 0
                : this.price.min;
        },
        /**
         * Max quantity is set for client
         */
        disabledQuantity() {
            return !this.isSaleUser && this.price.up_to !== 'inf';
        },
        /**
         * Product get total quantity when it hasn't custom pricings
         */
        quantityProduct() {
            if (this.isSaleUser) return this.price.qt;

            // On last stage, free licences are included
            if (this.price.up_to === 'inf') {
                return !!this.freeLicences.qt
                    ? this.price.qt + this.freeLicences.qt
                    : this.price.qt;
            }
            if (this.paidLicences.length !== 1 && this.price.up_to !== 'inf') return this.price.qt;

            return this.product.quantity;
        },
        licencesBeDeleted() {
            return this.product.quantity < this.product.availablesLicences;
        },
        tooltipLabel() {
            return this.disabledQuantity
                ? this.$l10n.__(
                      'Pour modifier les paliers tarifaires personnalisés, %(br)s merci de contacter un commercial',
                      { br: '<br>' },
                  )
                : this.$l10n.__(
                      'Pour réduire le nombre de licences, %(br)s merci de contacter un commercial',
                      { br: '<br>' },
                  );
        },
        paidLicences() {
            return this.product.customPricing.filter((price) => price.unit_amount !== 0);
        },
    },
    methods: {
        handleDecreaseTooltip(e, state) {
            if (
                e.target.classList.contains('is-disabled') &&
                this.product.quantity !== 0 &&
                this.paidLicences.length === 1
            )
                this.showTooltip = state;
        },
    },
};
</script>
